import { makeRequest } from './data_utils';

const loadUserStats = () => {
  return makeRequest('stats/', 'GET');
};

export const dataStats = {
    loadUserStats
};